import { apiSlice } from "api/apiSlice";

import {
    createSelector,
    createEntityAdapter,
} from "@reduxjs/toolkit";


const categoryAdapter = createEntityAdapter({
    sortComparer: (a, b) => a.name.localeCompare(b.name),
})

const initialState = categoryAdapter.getInitialState({
    categoriesDetails : {
        page: 0,
        filters: {},
        categoriesPerpage: 20,
        total_results: 0
    },
    listCategories : [],
    status : 'idle', // loading | succeeded | failed
    error : null
})

export const categoryApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getDistributerCategories: builder.query({
            query: params => ({ url: `distributerCategories`, params }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const loadedCategory = responseData.categories.map(category => {
                    /* eslint-disable */
                    const newcategory = category;
                    newcategory.id = category.id;
                    newcategory.icon = category.icon;
                    return newcategory
                });
                initialState.categoriesDetails = {
                    ...initialState.categoriesDetails,
                        page: responseData.page,
                        filters: responseData.filters ,
                        categoriesPerpage: responseData.categoriesPerpage,
                        total_results: responseData.total_results
                }
                responseData.parent && loadedCategory.push({name : 'No parent',parent:'/',category:'/', id:0, quantity : 0,statistics:{quantity:0 ,sold:0}});
                return categoryAdapter.setAll(initialState, loadedCategory)
            },
            /* eslint-disable */
            providesTags: (result, error, id) => // [{ type: 'Category', arg }]
             {
                /* eslint-disable */
                if (result?.ids) {
                    return [
                        { type: 'DistributerCategory', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'DistributerCategory', id }))
                    ]
                } else return [{ type: 'DistributerCategory', id: 'LIST' }]
            }
        }),
        
        getUserDistributerCategory: builder.query({
            query: (id) => ({ url: `userDistributerCategories/${id}` }),
            validateStatus: (response, result) => response.status === 200 && !result.isError,
            transformResponse: responseData => {
                const loadedCategory = responseData;
                return loadedCategory
            },
            /* eslint-disable */
            providesTags: (result, error, id) => [{ type: 'DistributerCategory', id }],
        }),
        
        addNewDistributerCategory: builder.mutation({
            query: initialCategoryData => ({
                url: '/distributerCategory',
                method: 'POST',
                body: {
                    ...initialCategoryData,
                }
            }),
            invalidatesTags: [
                { type: 'DistributerCategory', id: "LIST" }
            ]
        }),
        updateDistributerCategory: builder.mutation({
            query: initialCategoryData => ({
                url: '/distributerCategory',
                method: 'PATCH',
                body: {
                    ...initialCategoryData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'DistributerCategory', id: arg.id }
            ]
        }),
        
        deleteDistributerCategory: builder.mutation({
            query: ({ id }) => ({
                url: `/distributerCategory`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'DistributerCategory', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetDistributerCategoriesQuery,
    useGetUserDistributerCategoryQuery,
    useAddNewDistributerCategoryMutation,
    useUpdateDistributerCategoryMutation,
    useDeleteDistributerCategoryMutation,
} = categoryApiSlice

// returns the query result object
export const selectCategoryResult = categoryApiSlice.endpoints.getDistributerCategories.select()

// creates memoized selector
const selectCategoryData = createSelector(
    selectCategoryResult,
    categoryResult => categoryResult.data // normalized state object with ids & entities
)
//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllDistributerCategories,
    selectById: selectDistributerCategoryById,
    selectIds: selectDistributerCategoryIds
    // Pass in a selector that returns the category slice of state
} = categoryAdapter.getSelectors(state => selectCategoryData(state) ?? initialState)

export const selectDistributerCategoryByUser = createSelector(
    [selectAllDistributerCategories,(state, userId) => userId],
    (categorys, userId) => categorys.find(category => category.userId === userId)
);
